import { UnderlineMarkSpec, UNDERLINE_KEY } from '@techchange/pm-specs';

import UnderlineButton from './components/UnderlineButton';
import underlineKeymap from './plugins/keymap';

const underline = {

	marks() {

		return {
			[UNDERLINE_KEY]: UnderlineMarkSpec,
		};

	},

	plugins() {

		return [underlineKeymap];

	},

	toolbarButtons() {

		return [{ Button: UnderlineButton, key: 'UnderlineButton' }];

	},

};

export default underline;
